// extracted by mini-css-extract-plugin
export default {"page-title":"input_page-title__rMDJg","container":"input_container__FP5N8"};